export const V2_COMPONENT_ROHS_BRIEFING_ID_PREFIX = 'v2-component-rohs'
